<template>
  <v-container fluid>
    <v-expansion-panel style="margin-bottom: 50px;">
      <v-expansion-panel-content class="mycustomExpansionPanel">
        <template v-slot:actions>
          <v-icon large color="primary">$vuetify.icons.expand</v-icon>
        </template>
        <template v-slot:header>
          <div>
            <v-icon color="primary">search</v-icon>
            <span class="pl-2 subheading">Custom Search Panel</span>
          </div>
        </template>
        <v-layout row wrap align-center>
          <v-flex>
            <v-card class="px-3">
              <v-layout row wrap align-center class="py-3">
                <v-flex xs12 sm12 md4>
                  <v-text-field
                    class="ma-2"
                    v-model="searchParam.reg_no"
                    label="Search By Reg No"
                    clearable
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md4>
                  <v-text-field
                    class="ma-2"
                    v-model="searchParam.college_code"
                    label="Search By College Code"
                    clearable
                  ></v-text-field>
                </v-flex>

                <v-flex
                  xs12
                  sm12
                  md4
                  style="margin-top:1px; margin-bottom:8px;"
                >
                  <v-select
                    v-model="searchParam.confirm_status"
                    :items="items"
                    item-text="status"
                    item-value="value"
                    label="Select By Status"
                    persistent-hint
                    return-object
                    single-line
                    clearable
                  ></v-select>
                </v-flex>

                <v-flex
                  xs12
                  sm12
                  md12
                  style="margin-top:5px;margin-bottom:8px;"
                >
                  <v-layout justify-center row fill-height align-center>
                    <v-btn
                      color="primary"
                      large
                      dark
                      @click="validationForm('search')"
                    >
                      <v-icon center dark>search</v-icon>Search
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-card color="white">
      <v-layout row>
        <v-card flat>
          <v-badge left overlap>
            <template v-slot:badge>
              <v-btn
                round
                color="primary"
                fab
                small
                style="margin-top: -1.3em;"
                class="elevation-0"
                v-if="pagination.totalItems > 0"
                >{{ pagination.totalItems }}</v-btn
              >
            </template>
            <v-card-text class="title">Incourse Candidate List</v-card-text>
          </v-badge>
        </v-card>
        <v-divider class="my-2" vertical></v-divider>

        <v-spacer />

        <!-- <v-btn color="primary" dark @click="validationForm('export_pdf')">
          Export As PDF
          <v-icon right dark>cloud_download</v-icon>
        </v-btn>
        <v-btn color="primary" dark @click="validationForm('export_xl')">
          Export As Excel
          <v-icon right dark>cloud_download</v-icon>
        </v-btn> -->
      </v-layout>
    </v-card>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="getIncourseCandidatesListAdmin.data"
      class="elevation-1"
      :total-items="pagination.totalItems"
      :pagination.sync="pagination"
      :rows-per-page-items="pagination.rowsPerPageItems"
      item-key="reg_no"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            {{ props.item.rn }}
          </td>
          <td>
            {{ props.item.reg_no }}
          </td>
          <td>
            {{ props.item.name }}
          </td>
          <td>{{ props.item.college_code }} - {{ props.item.college_name }}</td>
          <td>{{ props.item.subject_code }} - {{ props.item.subject_name }}</td>
          <td>
            {{ props.item.ac_session }}
          </td>
          <td class="text-center" style="text-align: center;">
            <v-chip
              small
              :color="props.item.confirm_status == 1 ? 'green' : 'red'"
              text-color="white"
            >
              {{ props.item.confirm_status == 1 ? "Confirmed" : "Pending" }}
            </v-chip>
          </td>
          <td>
           <div style="display: flex;">
             <v-btn
              small
              fab
              color="primary"
              @click="
                viewDetails(
                  props.item.form_fill_up_id,
                  props.item.name,
                  props.item.reg_no,
                )
              "
            >
              <v-icon>info</v-icon>
            </v-btn>
            <v-btn
              small
              fab
              color="red"
              :disabled="props.item.confirm_status == 0"
              @click="cancleData(props.item.form_fill_up_id)"
            >
              <v-icon style="color: white;">close</v-icon>
            </v-btn>
           </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <template>
      <v-layout row justify-center>
        <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          persistent
          transition="dialog-bottom-transition"
        >
          <template v-slot:activator="{ on }">
            <!-- <v-btn color="primary" dark v-on="on">Open Dialog</v-btn> -->
          </template>
          <v-card>
            <v-card-title style="background-color:#3F51B5; color:white;">
              <span class="headline"
                >Incourse Marks ({{ marksReg }} - {{ marksName }})</span
              >
              <v-spacer></v-spacer>
              <v-btn color="red" fab dark small @click="dialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text style="text-align: end;">
              <v-btn color="indigo" style="color:#fff;" @click="addPaper()">
                <v-icon style="color:#fff">add</v-icon> Add New Paper
              </v-btn>
              <v-dialog v-model="addpaperDialog" persistent max-width="1030">
                <v-toolbar>
                  <v-toolbar-title>
                    <div class="title">Add New Paper</div>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn round outline flat @click="addpaperDialog = false">
                    <span class="mx-2 subheading">Close</span>(
                    <v-icon>close</v-icon>)
                  </v-btn>
                </v-toolbar>
                <v-card>
                  <v-layout row wrap class="ml-4 py-4">
                    <v-flex md12>
                      <div style="text-align: end; margin-right: 20px;;">
                        <h3>
                          Total selected Papers:
                          <v-btn fab small color="primary">
                            {{ selectedPaperCodes.length }}
                          </v-btn>
                        </h3>
                      </div>
                      <v-autocomplete
                        v-model="selectedPaperCodes"
                        :items="getallPaperInfo.data"
                        item-value="paper_code"
                        :item-text="
                          (item) => item.paper_code + ' - ' + item.paper_name
                        "
                        label="Select Papers"
                        multiple
                        small-chips
                        deletable-chips
                        clearable
                        menu-props="auto"
                      >
                        <!-- ITEM WITH CHECKBOX -->
                        <template v-slot:item="data">
                          <v-list-tile v-bind="data.attrs" v-on="data.on">
                            <v-list-tile-action>
                              <v-checkbox
                                :input-value="
                                  selectedPaperCodes.includes(
                                    data.item.paper_code,
                                  )
                                "
                                @change="togglePaper(data.item.paper_code)"
                                hide-details
                              ></v-checkbox>
                            </v-list-tile-action>
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{ data.item.paper_code }} -
                                {{ data.item.paper_name }}
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-autocomplete>

                      <div style="text-align: center;">
                        <v-btn
                          dark
                          small
                          color="indigo"
                          @click="addPaperOnPL()"
                        >
                          Submit
                        </v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-dialog>
              <v-container grid-list-md>
                <!-- {{ getIncourseMarksAdmin[0].core_paper.degree_code }} -->
                <v-data-table
                  :loading="loading"
                  :headers="marksHeaders"
                  :items="getIncourseMarksAdmin"
                  class="elevation-1"
                  hide-actions
                >
                  <template v-slot:items="props">
                    <tr>
                      <td style="text-align: left;">
                        {{ props.index + 1 }}
                      </td>
                      <td style="text-align: left;">
                        <v-icon v-if="props.item.inc_confirm_status == 1"
                          >done_all</v-icon
                        >
                        <span v-else style="margin-left: 28px;"></span>
                        {{ props.item.paper_code }} - {{ props.item.pap_name }}
                      </td>
                      <td style="text-align: left;">
                        <span v-if="props.item.incourse_paper_marks > 0">
                          {{ props.item.incourse_paper_marks }}</span
                        >
                        <span v-else>-</span>
                      </td>
                      <td style="text-align: left;">
                        <span v-if="props.item.att_incourse_marks > 0">
                          {{ props.item.att_incourse_marks }}</span
                        >
                        <span v-else>-</span>
                      </td>
                      <td style="text-align: left;">
                        <span v-if="props.item.incourse_marks > 0">
                          {{ props.item.incourse_marks }}</span
                        >
                        <span v-else>-</span>
                      </td>
                      <td style="text-align: left;">
                        <v-btn
                          style="color: white;"
                          small
                          fab
                          color="red"
                          @click="
                            processDelete(
                              props.item.form_fill_up_id,
                              props.item.paper_code,
                            )
                          "
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
    <v-dialog v-model="confirmDialog" persistent max-width="500px">
      <v-card style="border-radius:10px">
        <v-toolbar dark color="indigo" class="my-tool pa-1" style flat>
          <v-spacer></v-spacer>
          <v-icon x-large style="font-size: 50px;">info</v-icon>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="title pa-4 text-xs-center"
          >Are you sure that you want to <b style="color: red;">Delete</b> this
          Paper?</v-card-text
        >

        <v-divider></v-divider>
        <v-card-actions class="pt-0 pb-0">
          <v-spacer></v-spacer>
          <v-btn color="primary" flat text @click="removePaper()">
            <div class="title text-xs-center">Yes</div>
          </v-btn>
          <v-spacer></v-spacer>
          <v-divider vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn color="primary" text flat large @click="close()">
            <div class="title text-xs-center">Cancel</div>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import common_activities_get from "@/mixin/get_activities_time_publish";
import commonGet from "@/mixin/common_getters_mixin";

export default {
  mixins: [commonGet, common_activities_get],
  data() {
    return {
      current_privilege: "",
      college_user: "",
      loading: false,
      sl_count: 0,
      searchParam: {
        reg_no: "",
        confirm_status: "",
        display_type: "",
      },
      pagination: {
        rowsPerPage: 50,
        rowsPerPageItems: [50, 100, 150, 200, 250],
        page: 1,
        totalItems: 0,
      },
      headers: [
        { text: "SL", value: "rn", align: "left", sortable: false },
        { text: "Reg No", value: "reg_no", align: "left", sortable: false },
        { text: "Name", value: "name", align: "left", sortable: false },
        {
          text: "College code & Name",
          value: "",
          align: "left",
          sortable: false,
        },
        {
          text: "Subject code & Name",
          value: "",
          align: "left",
          sortable: false,
        },
        { text: "AC Session", value: "", align: "left", sortable: false },
        {
          text: "Status",
          value: "confirm_status",
          align: "left",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "left",
          sortable: false,
        },
      ],

      marksHeaders: [
        { text: "SL", value: "rn", align: "left", sortable: false },
        {
          text: "Paper Code & Name",
          value: "",
          align: "left",
          sortable: false,
        },
        {
          text: "Incourse Marks (Paper)",
          value: "",
          align: "left",
          sortable: false,
        },
        {
          text: "Incourse Marks (Attandance)",
          value: "",
          align: "left",
          sortable: false,
        },
        {
          text: "Total Incourse Marks",
          value: "",
          align: "left",
          sortable: false,
        },
        {
          text: "Action",
          value: "",
          align: "left",
          sortable: false,
        },
      ],

      // pagination
      page: 1,
      per_page: 50,
      total: 0,

      items: [
        { status: "Confirmed", value: "1" },
        { status: "Pending", value: "0" },
      ],
      dialog: false,
      marksReg: "",
      marksName: "",
      confirmDialog: false,
      formFillUpId: "",
      paperCode: "",
      addpaperDialog: false,
      selectedPaperCodes: [],
      subject_code: "",
      degree_group_code: "",
      degree_code: "",
    };
  },
  computed: {
    getIncourseCandidatesListAdmin() {
      return this.$store.getters.getIncourseCandidatesListAdmin;
    },
    getIncourseMarksAdmin() {
      return this.$store.getters.getIncourseMarksAdmin;
    },
    someSelected() {
      return this.selectedPaperCodes.length > 0 && !this.allSelected;
    },
    selectIcon() {
      if (this.someSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    getallPaperInfo() {
      return this.$store.getters.getStudentFFpaperData;
    },
  },
  watch: {
    pagination() {
      this.candidateList();
    },
  },
  created() {
    this.$store.dispatch("fetchExamWisePapers", {
      exam_code: this.getLoggedInExam.code,
    });
  },
  methods: {
    setLimit() {
      const { page, rowsPerPage, sortBy } = this.pagination;
      this.searchParam.page = page;
      this.searchParam.limit = rowsPerPage;
      this.searchParam.sort = sortBy;
      this.searchParam.exam_code = this.getLoggedInExam.code;
      this.searchParam.exam_year = this.getLoggedInYear.year;
      this.searchParam.college_code = this.searchParam.college_code;
      this.searchParam.degree_code = this.searchParam.degree_code;
      this.searchParam.degree_group_code = this.searchParam.degree_group_code;
      this.searchParam.subject_code = this.searchParam.subject_code;
      this.reg_no = this.searchParam.reg_no ? this.searchParam.reg_no : "";
      this.searchParam.confirm_status = this.searchParam.confirm_status
        ? this.searchParam.confirm_status.value
        : "";
      this.searchParam.display_type = this.searchParam.display_type
        ? this.searchParam.display_type
        : "";
    },
    candidateList() {
      try {
        if (this.searchParam.display_type) {
          this.loading = false;
        } else {
          this.loading = true;
        }
        this.setLimit();
        this.$store
          .dispatch("fetchIncourseCandidatesListAdmin", this.searchParam)

          .then((res) => {
            this.loading = false;

            this.sl_count = res.data.from || 0;

            this.pagination.totalItems = res.data.total || 0;
          });
      } catch (ex) {
        this.loading = false;
        console.log(ex);
      }
    },
    validationForm(type) {
      if (type == "search") {
        this.searchParam.display_type = "";
        this.candidateList();
      } else if (type == "export_pdf") {
        this.searchParam.confirm_status = "";
        this.searchParam.reg_no = "";
        this.searchParam.display_type = "export_pdf";
        this.candidateList();
      } else if (type == "export_xl") {
        this.searchParam.confirm_status = "";
        this.searchParam.reg_no = "";
        this.searchParam.display_type = "export_xl";
        this.candidateList();
      }

      // this.$validator.validateAll().then((isValid) => {
      //   if (isValid && item == 1) {
      //     this.candidateList(item);
      //   }
      //   if (isValid && item == 0) {
      //     this.MarkSheet();
      //   }
      // });
    },
    viewDetails(formFillUpId, name, reg) {
      this.marksReg = reg;
      this.marksName = name;
      this.formFillUpId = formFillUpId;
      console.log("View details for form fill up ID:", formFillUpId);
      // Implement the logic to view details based on the formFillUpId
      this.$store
        .dispatch("fetchIncourseMarksAdmin", { form_fill_up_id: formFillUpId })
        .then((res) => {
          this.dialog = true;
          console.log("Incourse Marks Details:", res.data);
          // You can navigate to a details page or show a modal with the details
        })
        .catch((error) => {
          console.error("Error fetching incourse marks details:", error);
        });
    },
    cancleData(formFillUpId) {
      // Implement the logic to cancel data based on the formFillUpId
      console.log("Cancel data for form fill up ID:", formFillUpId);
      this.$store
        .dispatch("cancelIncourseSubmissionbyAdmin", {
          form_fill_up_id: formFillUpId,
        })
        .then((res) => {
          console.log("Incourse submission cancelled successfully:", res.data);
          // Refresh the candidate list after cancellation
          this.candidateList();
        })
        .catch((error) => {
          console.error("Error cancelling incourse submission:", error);
        });
    },

    processDelete(formFillUpId, paperCode) {
      this.formFillUpId = formFillUpId;
      this.paperCode = paperCode;
      this.confirmDialog = true;
    },

    togglePaper(code) {
      const index = this.selectedPaperCodes.indexOf(code);
      if (index === -1) {
        this.selectedPaperCodes.push(code);
      } else {
        this.selectedPaperCodes.splice(index, 1);
      }
    },

    addPaper() {
      this.addpaperDialog = true;
      let payloadData = {
        subject_code: this.getIncourseMarksAdmin[0].core_paper.subject_code,
        degree_group_code: this.getIncourseMarksAdmin[0].core_paper
          .degree_group_code,
        degree_code: this.getIncourseMarksAdmin[0].core_paper.degree_code,
        sort: "degree_code",
        exam_code: this.getLoggedInExam.code,
        exam_year: this.getLoggedInYear.year,
      };
      console.log(payloadData);
      this.$store.dispatch("addNewPaperData", payloadData).then((rsp) => {
        // this.searchProbableCollegeWise()
      });
    },

    addPaperOnPL() {
      // Implement the logic to add paper on PL based on the formFillUpId and paperCode
      console.log(
        "Add paper on PL for form fill up ID:",
        this.marksReg,
        "and paper code:",
        this.selectedPaperCodes,
      );
      this.$store
        .dispatch("addPaperOnPL", {
          reg_no: this.marksReg,
          papers: this.selectedPaperCodes,
          exam_code: this.getLoggedInExam.code,
          exam_code: this.getLoggedInExam.code,
          exam_year: this.getLoggedInYear.year,
        })
        .then((res) => {
          console.log("Paper added on PL successfully:", res.data);
          this.selectedPaperCodes = [];
          this.addpaperDialog = false;
          // Refresh the incourse marks details after adding the paper
          this.viewDetails(this.formFillUpId, this.marksName, this.marksReg);
        })
        .catch((error) => {
          console.error("Error adding paper on PL:", error);
        });
    },
    removePaper() {
      // Implement the logic to remove paper based on the formFillUpId and paperCode
      console.log(
        "Remove paper for form fill up ID:",
        this.formFillUpId,
        "and paper code:",
        this.paperCode,
      );
      this.$store
        .dispatch("removePaperFromPL", {
          form_fill_up_id: this.formFillUpId,
          paper_code: this.paperCode,
        })
        .then((res) => {
          console.log("Paper removed from PL successfully:", res.data);
          this.confirmDialog = false;
          // Refresh the incourse marks details after removing the paper
          this.viewDetails(this.formFillUpId, this.marksName, this.marksReg);
        })
        .catch((error) => {
          console.error("Error removing paper from PL:", error);
        });
    },
    close() {
      this.confirmDialog = false;
    },
  },
};
</script>
<style lang=""></style>
